import { postAddView, getViewParamsByName } from "@/api/common";
import TtlLocalStorage from "@/utils/storage";
const storage = new TtlLocalStorage({
    namespace: 'CACHE.'
})

/**
 * @description 缓存机制，单例
 */
export default class Cache {
    // 缓存常量
    static CACHE_NAME  = 'CACHE_VIEW'

    /**
     * 缓存名
     * @param key
     * @returns {string}
     */
    static getModuleName (key) {
        return `CACHE_${key}`
    }

    constructor(mode = 'remote') {
        // 缓存key列表
        this.cacheList = []
        // 缓存存储位置
        this.cacheSaveMode = mode

    }

    /**
     * 获取当前模块缓存
     * @param key 模块名
     * @returns {Promise<AxiosResponse<any>|T>}
     */
    async getCache (key = '') {
        let params
        try {
            const cacheData = await this.getCacheData(Cache.getModuleName(key))
            params = {
                ...cacheData
            }
            return params
        } catch (e) {
            return null
        }
    }

    //清除所有缓存
    deleteCache(){
        this.cacheList=[];
        for(let i in localStorage){
            if(i.indexOf('CACHE')!==-1){
                localStorage.removeItem(i)
            }
        }
    }

    /**
     * 新增缓存
     * @param key 模块名
     * @param param 缓存数据
     * @returns {Promise<AxiosResponse<any>|boolean>}
     */
    async setCache (key = '', param) {
        if (!key) {
            console.warn('缺少参数{key}')
            return false
        }
        const params = {
            params: param ? JSON.stringify(param) : null,
            module: Cache.getModuleName(key),
            name: Cache.CACHE_NAME
        }
        let status
        try {
            status = await this.setCacheData(Cache.getModuleName(key), params)
            if (status) {
                const localCacheIndex = this.findLocalCacheIndex(key)
                if (localCacheIndex >= 0) {
                    this.cacheList[localCacheIndex].params = params
                } else {
                    this.cacheList.push({
                        key: Cache.getModuleName(key),
                        params
                    })
                }
            }
        } catch (e) {
            status = false
        }
        return status
    }

    /**
     * 根据存储模式获取缓存位置
     * @param key
     * @returns {Promise<void>}
     */
    async getCacheData (key) {
        const mode = this.cacheSaveMode
        const cacheInMemory = this.cacheList.find(v => v.key === key)
        let cacheData
        if (cacheInMemory) {
            return cacheInMemory.params
        }

        try {
            if (mode === 'remote') {
                const params = await getViewParamsByName(key, Cache.CACHE_NAME)
                cacheData = {
                    module: key,
                    name: Cache.CACHE_NAME,
                    params
                }
            } else {
                const storageCache = await storage.get(key)
                cacheData = storageCache ? storageCache : null
            }
        } catch (e) {
            console.warn('缓存获取失败')
        }

        return cacheData
    }

    /**
     * 根据存储模式设置缓存
     * @param key
     * @param param
     * @returns {Promise<void>}
     */
    async setCacheData (key = '', params = {}) {
        const mode = this.cacheSaveMode
        let status

        try {
            if (mode === 'remote') {
                await postAddView(params)
            } else {
                await storage.set(key, params)
            }
            status = true
            return status
        } catch (e) {
            status = false
            return status
        }
    }

    /**
     * 查找内存中的查询缓存
     * @param key
     * @returns {Object}
     */
    findLocalCache (key) {
        return this.cacheList.find(v => v.key === Cache.getModuleName(key))
    }

    /**
     * 查找内存中缓存索引
     * @param key
     * @returns {number}
     */
    findLocalCacheIndex (key) {
        return this.cacheList.findIndex(v => v.key === Cache.getModuleName(key))
    }


}
